import {GET_LOGIN_REQUESTED} from "resources/actionTypes";

export function getLogin(userLogin,navigate,setOnOtp) {
  const data ={
    userLoginPayload:userLogin,
    navigate:navigate,
    setOnOtp: setOnOtp
  }
  return {
    type: GET_LOGIN_REQUESTED,
    payload: data,
  };
}
